/** Additional errors from supplied contract artifacts; legacy selectors remain supported. */
export const providedProtocolErrorAbi = [
    { type: "error", name: "ERC1967ProxyUninitialized", inputs: [] },
    {
        type: "error",
        name: "BeaconInvalidImplementation",
        inputs: [{ name: "implementation", type: "address" }],
    },
    {
        type: "error",
        name: "InvalidOfficialContract",
        inputs: [{ name: "candidate", type: "address" }],
    },
    { type: "error", name: "SafeERC20FailedOperation", inputs: [{ name: "token", type: "address" }] },
    { type: "error", name: "FuelX3RequiresActiveFuel", inputs: [] },
    {
        type: "error",
        name: "LiquidityActivationPending",
        inputs: [
            { name: "failAfter", type: "uint256" },
            { name: "currentTime", type: "uint256" },
        ],
    },
    { type: "error", name: "AlreadyConsumed", inputs: [] },
    {
        type: "error",
        name: "ERC20InsufficientAllowance",
        inputs: [
            { name: "spender", type: "address" },
            { name: "allowance", type: "uint256" },
            { name: "needed", type: "uint256" },
        ],
    },
    {
        type: "error",
        name: "ERC20InsufficientBalance",
        inputs: [
            { name: "sender", type: "address" },
            { name: "balance", type: "uint256" },
            { name: "needed", type: "uint256" },
        ],
    },
    { type: "error", name: "ERC20InvalidApprover", inputs: [{ name: "approver", type: "address" }] },
    { type: "error", name: "ERC20InvalidReceiver", inputs: [{ name: "receiver", type: "address" }] },
    { type: "error", name: "ERC20InvalidSender", inputs: [{ name: "sender", type: "address" }] },
    { type: "error", name: "ERC20InvalidSpender", inputs: [{ name: "spender", type: "address" }] },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "AlreadyInitialized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "identifier",
                type: "uint256",
            },
        ],
        name: "InvalidIdentifier",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "projectToken",
                type: "address",
            },
        ],
        name: "InvalidProjectTokenAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [],
        name: "RenounceWhilePaused",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "enum AssetKind",
                name: "kind",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "InvalidAsset",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minimum",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maximum",
                type: "uint256",
            },
        ],
        name: "InvalidByteLength",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "minerId",
                type: "uint256",
            },
        ],
        name: "UnauthorizedClaimer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "mode",
                type: "uint8",
            },
        ],
        name: "UnsupportedLiquidityMode",
        type: "error",
    },
];
//# sourceMappingURL=providedErrors.js.map